'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var usercenter = function usercenter() {
  return import('@/page/user-center');
};
var mycourse = function mycourse() {
  return import('@/page/user-center/mycourse');
};
var mymistakes = function mymistakes() {
  return import('@/page/user-center/my-mistakes');
};
var myclass = function myclass() {
  return import('@/page/user-center/myclass');
};
var myonlineclass = function myonlineclass() {
  return import('@/page/user-center/myonlineclass');
};
var myOrder = function myOrder() {
  return import('@/page/user-center/my-order');
};
var studyarchives = function studyarchives() {
  return import('@/page/user-center/studyarchives');
};
var studyarchivesYears = function studyarchivesYears() {
  return import('@/page/user-center/studyarchives/years');
};
var studyarchivesOnDuty = function studyarchivesOnDuty() {
  return import('@/page/user-center/studyarchives/classes');
};
var studyarchivesNoDuty = function studyarchivesNoDuty() {
  return import('@/page/user-center/studyarchives/classes');
};
var studyarchivesOnLineClass = function studyarchivesOnLineClass() {
  return import('@/page/user-center/studyarchives/classes');
};
var studyarchivesOtherUnitsClass = function studyarchivesOtherUnitsClass() {
  return import('@/page/user-center/studyarchives/classes');
};
var studyarchivescourse = function studyarchivescourse() {
  return import('@/page/user-center/studyarchives/course');
};
var studyarchivesactivity = function studyarchivesactivity() {
  return import('@/page/user-center/studyarchives/activity');
};
var studyarchivestraining = function studyarchivestraining() {
  return import('@/page/user-center/studyarchives/training');
};
var studyarchivesexam = function studyarchivesexam() {
  return import('@/page/user-center/studyarchives/exam');
};
var qusetionnaire = function qusetionnaire() {
  return import('@/page/user-center/qusetionnaire');
};
var teacherGroom = function teacherGroom() {
  return import('@/page/user-center/teacher-groom');
};
var exam = function exam() {
  return import('@/page/user-center/exam');
};
var leave = function leave() {
  return import('@/page/user-center/my-leave');
};
var certificate = function certificate() {
  return import('@/page/user-center/my-certificate');
};
var mycheck = function mycheck() {
  return import('@/page/user-center/my-check');
};
var myCollection = function myCollection() {
  return import('@/page/user-center/my-collection');
};
var myMessage = function myMessage() {
  return import('@/page/notice-announcement/notice-list');
};
var myaccount = function myaccount() {
  return import('@/page/user-center/my-account');
};
var mytoonaccount = function mytoonaccount() {
  return import('@/page/user-center/my-toonaccount');
};
var myinfoconcat = function myinfoconcat() {
  return import('@/page/user-center/my-info-concat');
};
var myactivity = function myactivity() {
  return import('@/page/user-center/my-activity');
};
exports.default = [{
  path: '/usercenter',
  name: 'usercenter',
  component: usercenter,
  children: [{
    path: 'mycourse',
    name: 'mycourse',
    component: mycourse
  }, {
    path: 'questionnaire',
    name: 'questionnaire',
    component: qusetionnaire
  }, {
    path: 'myclass',
    name: 'myclass',
    component: myclass
  }, {
    path: 'myonlineclass',
    name: 'myonlineclass',
    component: myonlineclass
  }, {
    path: 'myOrder',
    name: 'myOrder',
    component: myOrder
  }, {
    path: 'studyarchives',
    name: 'studyarchives',
    component: studyarchives
  }, {
    path: 'vote',
    name: 'vote',
    component: qusetionnaire
  }, {
    path: 'teacherGroom',
    name: 'teacherGroom',
    component: teacherGroom
  }, {
    path: 'exam',
    name: 'exam',
    component: exam
  }, {
    path: 'leave',
    name: 'leave',
    component: leave
  }, {
    path: 'certificate',
    name: 'certificate',
    component: certificate
  }, {
    path: 'mymistakes',
    name: 'mymistakes',
    component: mymistakes
  }, {
    path: 'myCollection',
    name: 'myCollection',
    component: myCollection
  }, {
    path: 'myMessage',
    name: 'myMessage',
    component: myMessage
  }, {
    path: 'myaccount',
    name: 'myaccount',
    component: myaccount
  }, {
    path: 'mytoonaccount',
    name: 'mytoonaccount',
    component: mytoonaccount
  }, {
    path: 'myactivity',
    name: 'myactivity',
    component: myactivity
  }, {
    path: 'myinfoconcat',
    name: 'myinfoconcat',
    component: myinfoconcat
  }]
}, {
  path: '/studyarchivesYears',
  name: 'studyarchivesYears',
  alias: '/usercenter/studyarchives/studyarchivesYears',
  component: studyarchivesYears
}, {
  path: '/studyarchivesOnDuty',
  name: 'studyarchivesOnDuty',
  alias: '/usercenter/studyarchives/studyarchivesOnDuty',
  component: studyarchivesOnDuty
}, {
  path: '/studyarchivesOnLineClass',
  name: 'studyarchivesOnLineClass',
  alias: '/usercenter/studyarchives/studyarchivesOnLineClass',
  component: studyarchivesOnLineClass
}, {
  path: '/studyarchivesOtherUnitsClass',
  name: 'studyarchivesOtherUnitsClass',
  alias: '/usercenter/studyarchives/studyarchivesOtherUnitsClass',
  component: studyarchivesOtherUnitsClass
}, {
  path: '/studyarchivesNoDuty',
  name: 'studyarchivesNoDuty',
  alias: '/usercenter/studyarchives/studyarchivesNoDuty',
  component: studyarchivesNoDuty
}, {
  path: '/studyarchivescourse',
  name: 'studyarchivescourse',
  alias: '/usercenter/studyarchives/studyarchivesCourse',
  component: studyarchivescourse
}, {
  path: '/studyarchivesactivity',
  name: 'studyarchivesactivity',
  alias: '/usercenter/studyarchives/studyarchivesActivity',
  component: studyarchivesactivity
}, {
  path: '/studyarchivestraining',
  name: 'studyarchivestraining',
  alias: '/usercenter/studyarchives/studyarchivesTraining',
  component: studyarchivestraining
}, {
  path: '/studyarchivesexam',
  name: 'studyarchivesexam',
  alias: '/usercenter/studyarchives/studyarchivesExam',
  component: studyarchivesexam
}, {
  path: '/mycheck',
  name: 'mycheck',
  alias: '/usercenter/mycheck',
  component: mycheck
}];